import { render, staticRenderFns } from "./TableContracts.vue?vue&type=template&id=553d20af&scoped=true&"
import script from "./TableContracts.vue?vue&type=script&lang=js&"
export * from "./TableContracts.vue?vue&type=script&lang=js&"
import style0 from "./TableContracts.vue?vue&type=style&index=0&id=553d20af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d20af",
  null
  
)

export default component.exports